export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('table_label_teamName') || '部门团队',
    field: 'showTeamName',
    minWidth: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'String',
    slots: { default: 'showTeamName' },
  },
  {
    title: that.$l('table_salesPersonName') || '业务人员',
    field: 'userName',
    minWidth: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'String',
  },
  {
    title: that.$l('table_label_statisticsCustName') || '统计客户',
    field: 'custName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_orderCustName') || '下单客户',
    field: 'orderCustName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_orderEndCustName') || '下单终端客户',
    field: 'orderEndCustName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_masterCategoryName') || '产品分类',
    field: 'categoryName',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_orderType') || '订单类型',
    field: 'orderType',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_rptOrderMonth') || '年月',
    field: 'rptOrderMonth',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_goodsQty') || '产品数量',
    field: 'goodsQty',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_priceAmount') || '工厂成本',
    field: 'priceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_currencyUnit') || '成本单位',
    field: 'currencyUnit',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_salePriceAmount') || '销售金额',
    field: 'salePriceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_netSalePriceAmount') || '去佣金销售',
    field: 'netSalePriceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_salesCurrencyUnit') || '销售单位',
    field: 'salesCurrencyUnit',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_exchangeRate') || '当月汇率',
    field: 'exchangeRate',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title: that.$l('table_label_usdPriceAmount') || '工厂成本USD',
    field: 'usdPriceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_usdSalePriceAmount') || '销售金额USD',
    field: 'usdSalePriceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_usdNetSalePriceAmount') || '去佣金销售USD',
    field: 'usdNetSalePriceAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_usdOrderProfit') || '订单毛利USD',
    field: 'usdOrderProfit',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_hasShipping') || '是否已出运',
    field: 'hasShipping',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'hasShipping' },
  },
]
